import React, { useState } from 'react';
import client from '../api/client';

export default function ResetPasswordPage({ token, onComplete, on2faRequired }) {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm]   = useState('');
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8)  { setError('パスワードは8文字以上で入力してください'); return; }
    if (password !== confirm)  { setError('パスワードが一致しません'); return; }
    setLoading(true); setError('');
    try {
      const { data } = await client.post('/auth/reset-password', { token, new_password: password });
      if (data.requires_2fa) {
        // 2FA 有効ユーザーは中間トークンで 2FA 検証画面へ遷移
        on2faRequired?.(data.temp_token);
      } else {
        // 2FA なしユーザーは Cookie が発行済みなのでそのままアプリへ
        onComplete();
      }
    } catch (err) {
      setError(err.response?.data?.detail ?? 'リセットに失敗しました');
      setLoading(false);
    }
  };

  return (
    <div style={wrapStyle}>
      <div style={cardStyle}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: 44, lineHeight: 1, marginBottom: 10 }}>🔒</div>
          <div style={titleStyle}>新しいパスワードを設定</div>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="form-group">
            <label className="form-label">新しいパスワード（8文字以上）</label>
            <input className="form-input" type="password" placeholder="••••••••"
              value={password} onChange={e => setPassword(e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">パスワード（確認）</label>
            <input className="form-input" type="password" placeholder="••••••••"
              value={confirm} onChange={e => setConfirm(e.target.value)} />
          </div>
          {error && <div className="msg msg-error">{error}</div>}
          <button type="submit" className="btn btn-primary" disabled={loading}
            style={{ width: '100%', padding: '12px' }}>
            {loading ? <><span className="spinner" />設定中…</> : 'パスワードを変更'}
          </button>
        </form>
      </div>
    </div>
  );
}

const wrapStyle = {
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  minHeight: '100vh',
  background: 'linear-gradient(135deg, #FF6B9D 0%, #9B5FE3 60%, #7048D4 100%)',
  padding: '16px',
};
const cardStyle = {
  background: '#fff', borderRadius: 24,
  padding: 'clamp(24px, 7vw, 44px) clamp(20px, 6vw, 40px)',
  width: '100%', maxWidth: 400,
  boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
};
const titleStyle = {
  fontFamily: "'Nunito', 'M PLUS Rounded 1c', sans-serif",
  fontSize: 20, fontWeight: 900, color: '#7048D4',
};
